<template>
  <div>
    <Header />

    <div class="content-web container mt-5">
      <div class="table-box list-grid mb-5">
        <div class="row ml-0 mr-0">
          <div class="title col-lg-4 col-md-4 col-sm-4 col-xs-12">
            <h6>QUẢN LÝ CTTV</h6>
          </div>
          <div
            class="col-lg-8 col-md-8 col-sm-8 col-xs-12 d-flex justify-content-end pl-2"
          >
            <button
              type="button"
              class="btn btn-info mr-2"
              @click="showAddCTTV = true"
            >
              <i class="fa fa-plus mr-1"></i>Thêm CTTV
            </button>
          </div>
        </div>

        <div class="content-table">
          <table class="table table-responsive">
            <thead>
              <tr>
                <th style="width: 10%">ID</th>
                <th style="width: 50%">CCTV NAME</th>
                <th style="width: 30%">CCTV CODE</th>
                <th style="width: 20%">HÀNH ĐỘNG</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="items in dataManageCTTV" v-bind:key="items.id">
                <td>{{ items.id }}</td>
                <td>{{ items.name }}</td>
                <td>{{ items.code }}</td>
                <td>
                  <button
                    v-on:click="handleEditCTTV(items.id)"
                    class="btn btn-info"
                  >
                    <i class="fa fa-edit"></i>
                  </button>

                  <button
                    v-on:click="moveIdtoModel(items.id)"
                    data-toggle="modal"
                    data-target="#deleteManageCTTVForm"
                    class="btn btn-danger"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
       
        <!-- edit -->
         
        <el-dialog title="Thay đổi CTTV" :visible.sync="showEditForm" width="40%" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editDataCTTV" label-position="left" label-width="150px">
                  <el-form-item label="CTTV code" prop="cttvCode">
                    <el-input placeholder="CTTV code" v-model="editDataCTTV.code" ></el-input>
                  </el-form-item>                   
                  <el-form-item label="CTTV name" prop="cttvName">
                    <el-input  placeholder="CTTV name" v-model="editDataCTTV.name" ></el-input>
                  </el-form-item>              
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="showEditForm = false">Bỏ qua</el-button>
              <el-button type="primary" @click="editManageCTTV()">Đồng ý</el-button>              
            </div> 
        </el-dialog>

        <!-- delete -->
        <div
          class="modal fade"
          id="deleteManageCTTVForm"
          tabindex="-2"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header"></div>
              <div class="modal-body">Bạn có chắc muốn xóa CTTV này?</div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Hủy
                </button>
                <button
                  v-on:click="deleteManageCTTV"
                  type="button"
                  class="btn sku-btn"
                  data-dismiss="modal"
                >
                  Đồng ý
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4 pagination">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pagesize">
            <span v-if="perPage * page > totalData && totalData != 0"
              >{{ perPage * (page - 1) + 1 }}-{{ totalData }} của
              {{ totalData }}</span
            >
            <span v-if="perPage * page <= totalData && totalData != 0"
              >{{ perPage * (page - 1) + 1 }}-{{ perPage * page }} của
              {{ totalData }}</span
            >
            <span v-if="totalData == 0">0-0 của 0</span>
          </div>
          <div
            class="col-lg-7 col-md-7 col-sm-7 col-xs-12 d-flex justify-content-end pageindex"
          >
            <b-pagination
              v-if="totalData > perPage"
              v-model="page"
              pills
              :total-rows="totalData"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>

      </div>
    </div>
    <b-modal
      v-model="showAddCTTV"
      id="modal-prevent-closing"
      ref="modal"
      title="Thêm CTTV mới"
      @show="showAddForm"
    >
      <form>
        <input
          class="form-control input-name mb-2"
          v-model="textCTTVName"
          placeholder="Tên CTTV"
        />
        <input
          class="form-control input-name mb-2"
          v-model="textCode"
          placeholder="code"
        />
      </form>
      <template v-slot:modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="showAddCTTV = false"
        >
          Hủy
        </button>
        <button
          v-on:click="addManageCTTV"
          class="btn btn-primary"
          data-dismiss="modal"
        >
          Lưu
        </button>
      </template>
    </b-modal>

    <Footer />
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "axios";
import * as CONFIG from "../../config/index";
import helper from "../../common/helper";
import { BPagination } from "bootstrap-vue";
import Vue from "vue";

export default {
  name: "CTTVManager",
  components: {
    Header,
    Footer,
    vueDropzone: vue2Dropzone,
    "b-pagination": BPagination,
  },
  data() {
    return {
      page: 1,
      perPage: 5,
      totalPages: 0,
      totalData: 0,
      dataManageCTTV: [],
      idManageCTTV : null,
      manageCTTV: {
        name: null,
        code: null,
      },
      editDataCTTV: {
        id:null,
        name: null,
        code: null,
      },
      textCTTVName: null,
      textCode: null,
      showAddCTTV: false,
      showEditForm : false,
    };
  },
  watch: {
    page: {
      immediate: false,
      handler(newVal, oldVal) {
        this.getAll();
      },
    },
    pageFilterByStatus: {
      immediate: false,
      handler(newVal, oldVal) {
        this.filterByStatus(event);
      },
    },
  },
  mounted() {
    this.getStatus;
    this.getAll();
  },
  methods: {
    getAll: function () {
      this.axios
        .get(
          `${CONFIG.API_URL}/company/search?pageNo=` +
            this.page +
            `&pageSize=` +
            this.perPage
        )
        .then((resCTTV) => {
          this.dataManageCTTV = resCTTV.data.data.items;
          this.totalPages = Math.ceil(resCTTV.data.data.totals / this.perPage);
          this.totalData = resCTTV.data.data.totals;
        })
        .catch((e) => {});
    },
    pageChange: function (pageIndex) {
      this.page = pageIndex;
      if (this.selectedFilter == "null") {
        this.getAll();
      } else {
        this.getDataOption();
      }
    },

    moveIdtoModel: function (id) {
      this.idManageCTTV = id;
    },

    deleteManageCTTV: function (event) {
      this.axios
        .delete(`${CONFIG.API_URL}/company?id=` + this.idManageCTTV)
        .then((resCTTV) => {
          helper.successMsg("Xóa CTTV thành công");
          this.getAll();
        })
        .catch((e) => {
          helper.errMsg("Xóa CTTV thất bại");
        });
    },
    addManageCTTV: function (event) {
      this.manageCTTV.code = this.textCode;
      this.manageCTTV.name = this.textCTTVName;
      this.axios
        .post(`${CONFIG.API_URL}/company`, this.manageCTTV)
        .then((resNewCTTV) => {
          console.log("mrd" + resNewCTTV.data.message[0].code)
          if (resNewCTTV.data.message[0].code == "duplicate") {
            helper.errMsg("CTTV đã tồn tại!");
          } else {
            helper.successMsg("Thêm CTTV thành công.");
            this.getAll();
          }
          this.showAddCTTV = false;
        })
        .catch((e) => {
          helper.errMsg("Thêm CTTV thất bại");
        });
    },

    editManageCTTV: function (event) {
      this.axios
        .put(`${CONFIG.API_URL}/company`, this.editDataCTTV)
        .then((resUpdateCTTV) => {
          
          helper.successMsg("Sửa CTTV thành công.");
          this.getAll();
          
          this.showEditForm = false;
        })
        .catch((e) => {
          helper.errMsg("Sửa CTTV thất bại");
        });
    },

    getAuthHeader() {
      let token = Vue.$cookies.get("accessToken");
      return {
        Authorization: `Bearer ${token}`,
      };
    },
    showAddForm() {
      this.textCCTVName = null;
      this.textCode = null;
    },

    handleEditCTTV:function(id){
      console.log("handleEditCTTV : " +id)
      this.showEditForm = true;  
      this.axios
        .get(
          `${CONFIG.API_URL}/company/` + id
        )
        .then((resCTTV) => {
          this.editDataCTTV.id = id;
          this.editDataCTTV.code = resCTTV.data.data.code;
          this.editDataCTTV.name = resCTTV.data.data.name;    
        })
        .catch((e) => {});        
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/table_customs.css";
</style>


// WEBPACK FOOTER //
// src/components/pages/CTTVManager.vue